import { IconNotifications } from '@components/icons/notifications';
import { FilterConfigField } from '@components/table';
import { FilterData } from '@components/table/filters';

import { useStore } from 'models/Provider';

const activityFieldToExternalQuery = (filter: FilterData) => {
  if (!Array.isArray(filter.value)) return {};

  switch (filter.comparer) {
    case 'any_of':
    default:
      const obj: Record<string, any> = {};
      filter.value.forEach((val) => {
        obj[`unread_${val}`] = true;
      });
      return obj;
  }
};

export const useActivityFilter = (): FilterConfigField => {
  const { t } = useStore();

  return {
    id: 'activity',
    label: t('applicants.filters.unread.title'),
    icon: <IconNotifications />,
    type: 'multi_select',
    values: [
      { value: 'new_application', label: t('applicants.filters.unread.new_application') },
      { value: 'messages', label: t('applicants.filters.unread.messages') },
      { value: 'notes', label: t('applicants.filters.unread.notes') },
      { value: 'ratings', label: t('applicants.filters.unread.ratings') },
      { value: 'assigned_to', label: t('applicants.filters.unread.assigned_to') },
      { value: 'files', label: t('applicants.filters.unread.files') },
    ],
    allowedComparers: ['any_of'],
    toExternalQuery: activityFieldToExternalQuery,
  };
};
